<div class="plate">
  <div class="plate-inner">
    <ng-container *ngFor="let cell of cellsBeforeSpacer()">
      <div #cell
           class="plate-char plate-font"
           [class.is-locked]="cell.locked"
           [class.is-empty]="!cell.locked && cell.value === '_'"
           [class.is-active]="!cell.locked && editableIndices.indexOf(cell.index) === activeSlot"
           [class.is-shake]="shakeIndex === cell.index"
           [attr.data-idx]="cell.index"
           [attr.tabindex]="cell.locked ? null : 0"
           (click)="onCellClick(cell)">
        {{ cell.locked ? cell.value : (cell.value === '_' ? '?' : cell.value) }}
      </div>
    </ng-container>
    <div class="plate-gap" aria-hidden="true"></div>
    <ng-container *ngFor="let cell of cellsAfterSpacer()">
      <div #cell
           class="plate-char plate-font"
           [class.is-locked]="cell.locked"
           [class.is-empty]="!cell.locked && cell.value === '_'"
           [class.is-active]="!cell.locked && editableIndices.indexOf(cell.index) === activeSlot"
           [class.is-shake]="shakeIndex === cell.index"
           [attr.data-idx]="cell.index"
           [attr.tabindex]="cell.locked ? null : 0"
           (click)="onCellClick(cell)">
        {{ cell.locked ? cell.value : (cell.value === '_' ? '?' : cell.value) }}
      </div>
    </ng-container>
  </div>
</div>

<div class="status-row" [class.is-reject]="isReject" aria-live="polite">
  <span class="status-text">{{ statusText }}</span>
  <button type="button" class="clear-link"
          [class.is-hidden]="!hasLetters || isReject"
          (click)="clearAll()">Clear</button>
</div>

<button type="button" class="btn--search"
        [disabled]="hasLetters && !canSubmit"
        (click)="submit()">
  <span class="search-label">{{ searchLabel }}</span>
  <span class="arrow" aria-hidden="true">&rarr;</span>
</button>
<!-- Pattern preview badge intentionally removed: it duplicated the visible
     composer plate above and added nothing per Hugh's review. -->

